
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction, createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import { editLocationGroup } from 'state/location-groups/actions';


const openModal = createOpenModalAction('EditLocationGroupModal');
const closeModal = createCloseModalAction('EditLocationGroupModal');

export const startEditingLocationGroup = (locationGroupId, edits) => dispatch => {
    dispatch({
        type: actions.START_EDITING_LOCATION_GROUP,
        payload: { locationGroupId }
    })
    dispatch(editLocationGroup(locationGroupId, edits));
    dispatch(openModal());
}


export const stopEditingLocationGroup = () => dispatch => {
    dispatch({
        type: actions.STOP_EDITING_LOCATION_GROUP
    })
    dispatch(closeModal());
}